import React from 'react';
import image1 from "../../../Data/img/mehendi/newbridal.jpg";
import Formabout from '../../../Pages/Formabout';

const Contact = () => {
  return (
    <div className="min-h-screen flex items-center justify-center mt-10 py-10 bg-richblack-900 relative overflow-hidden">
      {/* Background Circles */}
      <div className="absolute -top-20 -left-20 w-96 h-96 bg-[#CFB250] rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob"></div>
      <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-white rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000"></div>
      <div className="absolute top-20 right-20 w-96 h-96 bg-black rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000"></div>

      {/* Container */}
      <div className="relative z-10 bg-white bg-opacity-10 backdrop-blur-lg rounded-lg shadow-2xl overflow-hidden flex flex-col md:flex-row w-full max-w-4xl gap-10">
        {/* Image Section */}
        <div className="md:w-1/2 w-full relative">
          <img
            src={image1}
            alt="Contact Us"
            className="object-cover h-full w-full opacity-80 hover:opacity-100 transition-opacity duration-500 ease-in-out"
          />
        </div>
        
        {/* Form Section */}
        <div className="md:w-1/2 w-full p-8 text-white">
          <h2 className="text-3xl font-bold  text-white mb-6 font-roboto">Get In Touch</h2>
          <p className="text-white mb-8 font-mono">We'd love to hear from you! Please fill out the form below.</p>
          <Formabout/>
        </div>
      </div>
    </div>
  );
};

export default Contact;
